import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { getTImeSheets } from "../actions/getTImeSheets.actions";
import { TimeSheetParams, TimeSheetResponse } from "../interfaces/time-sheet.interfaces";
import { timeSheetsQueryKeys } from "../queries/timeSheets.queries";

export const useTimeSheetsQuery = (
    params?: TimeSheetParams
): UseQueryResult<TimeSheetResponse, Error> => {
    return useQuery<TimeSheetResponse, Error>({
        queryKey: timeSheetsQueryKeys.list(params),
        queryFn: () => getTImeSheets(params),
        refetchOnMount: true,
        staleTime: 0,
        refetchOnWindowFocus: true,
    });
};